// IMPORTANT! Use unique keys for store inside producer app

export const DELIVERIES_SIGN_IN = 'DELIVERIES_SIGN_IN';
export const DELIVERIES_SIGN_OUT = 'DELIVERIES_SIGN_OUT';
export const DELIVERIES_MAKE_INITIALIZED = 'DELIVERIES_MAKE_INITIALIZED';
export const DELIVERIES_MAKE_NON_INITIALIZED = 'DELIVERIES_MAKE_NON_INITIALIZED';
export const DELIVERIES_CHANGE_LOADING = 'DELIVERIES_CHANGE_LOADING';
